import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { authFetch } from '../lib/authFetch';

export function useAppBadge(endpoint: string, enabled = true) {
  const { data } = useQuery<{ count: number }>({
    queryKey: ['app-badge-count', endpoint],
    queryFn: async () => {
      const res = await authFetch(endpoint);
      if (!res.ok) return { count: 0 };
      return res.json();
    },
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
    staleTime: 10000,
    enabled,
  });

  useEffect(() => {
    if (!('setAppBadge' in navigator)) return;
    const count = data?.count ?? 0;
    if (count > 0) {
      (navigator as any).setAppBadge(count).catch(() => {});
    } else {
      (navigator as any).clearAppBadge().catch(() => {});
    }
  }, [data?.count]);
}
